/**
 * PMS Provider constants and utilities
 * Shared across all applications for consistency
 */
/**
 * Supported Property Management System providers
 */
export const PMS_PROVIDERS = {
    APPFOLIO: 'appfolio',
    BUILDIUM: 'buildium',
    RENTVINE: 'rentvine',
};
/**
 * Array of all supported PMS providers for validation
 */
export const SUPPORTED_PMS_PROVIDERS = Object.values(PMS_PROVIDERS);
/**
 * Validate and normalize a PMS provider string
 * @param provider - Raw provider string to validate
 * @returns Validated PMSProvider
 * @throws Error if provider is not supported
 */
export function validatePMSProvider(provider) {
    if (!provider?.trim()) {
        throw new Error('PMS provider is required');
    }
    const normalized = provider.toLowerCase().trim();
    if (!SUPPORTED_PMS_PROVIDERS.includes(normalized)) {
        throw new Error(`Unsupported PMS provider '${provider}'. Supported providers: ${SUPPORTED_PMS_PROVIDERS.join(', ')}`);
    }
    return normalized;
}
/**
 * Get display name for a PMS provider
 */
export function getPMSProviderDisplayName(provider) {
    switch (provider) {
        case PMS_PROVIDERS.APPFOLIO:
            return 'AppFolio';
        case PMS_PROVIDERS.BUILDIUM:
            return 'Buildium';
        case PMS_PROVIDERS.RENTVINE:
            return 'RentVine';
    }
}
/**
 * Check if a provider supports a specific feature
 * @param provider - PMS provider
 * @param feature - Feature to check support for
 * @returns True if the provider supports the feature, false otherwise
 */
export function providerSupportsFeature(provider, feature) {
    // Feature matrix for each provider
    const featureMatrix = {
        [PMS_PROVIDERS.APPFOLIO]: {
            contacts: true,
            properties: true,
        },
        [PMS_PROVIDERS.BUILDIUM]: {
            contacts: false,
            properties: false,
        },
        [PMS_PROVIDERS.RENTVINE]: {
            contacts: false,
            properties: false,
        },
    };
    return featureMatrix[provider]?.[feature] ?? false;
}
//# sourceMappingURL=providers.js.map